import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './AnimatedVennDiagramRedesign.css';

const AnimatedVennDiagramRedesign = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger animation after component mounts
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const circleVariants = {
    hidden: { 
      scale: 0, 
      opacity: 0,
      x: 0,
      y: 0
    },
    visible: (i) => ({
      scale: 1,
      opacity: 0.85,
      x: 0,
      y: 0,
      transition: {
        duration: 1.5,
        delay: i * 0.6,
        ease: "easeOut"
      }
    }),
    hover: {
      scale: 1.08,
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeInOut"
      }
    }
  };

  const textVariants = {
    hidden: { 
      opacity: 0,
      y: 20
    },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        duration: 1.2,
        delay: i * 0.6 + 0.9,
        ease: "easeOut"
      }
    })
  };

  const pulseVariants = {
    pulse: {
      scale: [1, 1.03, 1],
      opacity: [0.85, 1, 0.85],
      transition: {
        duration: 5,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  };

  return (
    <div className="venn-diagram-container">
      <div className="venn-diagram-wrapper">
        <AnimatePresence>
          {isVisible && (
            <>
              {/* Simplify Circle (Yellow) */}
              <motion.div
                className="venn-circle simplify-circle"
                custom={0}
                initial="hidden"
                animate={isVisible ? "visible" : "hidden"}
                whileInView="visible"
                viewport={{ once: true }}
                whileHover="hover"
                variants={circleVariants}
              >
                <motion.div
                  className="circle-text"
                  custom={0}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  variants={textVariants}
                >
                  Simplify
                </motion.div>
                <motion.div
                  className="circle-pulse"
                  variants={pulseVariants}
                  animate="pulse"
                />
              </motion.div>

              {/* Focus Circle (Orange) */}
              <motion.div
                className="venn-circle focus-circle"
                custom={1}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                whileHover="hover"
                variants={circleVariants}
              >
                <motion.div
                  className="circle-text"
                  custom={1}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  variants={textVariants}
                >
                  Focus
                </motion.div>
                <motion.div
                  className="circle-pulse"
                  variants={pulseVariants}
                  animate="pulse"
                />
              </motion.div>

              {/* Credible Circle (Blue) */}
              <motion.div
                className="venn-circle credible-circle"
                custom={2}
                initial="hidden"
                animate={isVisible ? "visible" : "hidden"}
                whileInView="visible"
                viewport={{ once: true }}
                whileHover="hover"
                variants={circleVariants}
              >
                <motion.div
                  className="circle-text"
                  custom={2}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  variants={textVariants}
                >
                  Credible
                </motion.div>
                <motion.div
                  className="circle-pulse"
                  variants={pulseVariants}
                  animate="pulse"
                />
              </motion.div>
            </>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default AnimatedVennDiagramRedesign;
